<template>
  <div class="track-item">
    <div class="base-title">歌曲信息</div>
    <div class="info">
      <div>
        <span>歌曲ID</span>
        <span>{{ track.trackId }}</span>
      </div>

      <div>
        <span>歌曲名</span>
        <span>{{ track.trackName }}</span>
      </div>

      <div>
        <span>版本</span>
        <span>{{ versionMap[track.version] }}</span>
      </div>

      <div>
        <span>歌手</span>
        <span>{{ track.trackSingerList.map(item => item.singerName).join('、') }}</span>
      </div>

      <div>
        <span>专辑</span>
        <span>{{ track.albumName }}</span>
      </div>

      <div>
        <span>发行时间</span>
        <span>{{ track.publicTime }}</span>
      </div>

      <div>
        <span>词作者</span>
        <span>{{ track.trackLyricistList.map(item => item.singerName).join('、') }}</span>
      </div>

      <div>
        <span>曲作者</span>
        <span>{{ track.trackComposerList.map(item => item.singerName).join('、') }}</span>
      </div>

      <div>
        <span>歌曲状态</span>
        <span>{{ trackStatusMap[track.status] }}</span>
      </div>

      <div>
        <span>下架原因</span>
        <span>{{ hideReasonMap[track.hideReason] }}</span>
      </div>

      <div>
        <span>付费模式</span>
        <span>{{ paymentMap[track.trackPayment.paymentMode] }}</span>
      </div>
    </div>
    <el-divider></el-divider>

    <div class="base-title">当前</div>

    <el-row :gutter="40">
      <el-col :span="8">
        <copyright :type="COPYRIGHT_TYPE.TRACK" :list="track.trackCopyrightList"></copyright>
      </el-col>
      <el-col :span="8">
        <copyright :type="COPYRIGHT_TYPE.WORD" :list="track.trackWordCopyrightList"></copyright>
      </el-col>
      <el-col :span="8">
        <copyright :type="COPYRIGHT_TYPE.MUSIC" :list="track.trackMusicCopyrightList"></copyright>
      </el-col>
    </el-row>

    <el-divider></el-divider>

    <out-plat :list="track.trackCopyrightCompetitorList"></out-plat>

    <el-divider></el-divider>
    <div class="base-title">
      预期
      <template v-if="track.reviewStatus === 0">
        <el-button type="text" v-if="!editing" @click="handleEdit">人工调整</el-button>
        <el-button type="text" v-else @click="handleEdit">确认</el-button>
      </template>
    </div>

    <el-row :gutter="40">
      <el-col :span="8">
        <copyright
          ref="track"
          :type="COPYRIGHT_TYPE.TRACK"
          :editing="editing"
          :list="track.trackCopyrightList"
          :match="track.expectTrackCopyrightList[0]"
        ></copyright>
      </el-col>
      <el-col :span="8">
        <copyright
          ref="word"
          :type="COPYRIGHT_TYPE.WORD"
          :editing="editing"
          :list="track.trackWordCopyrightList"
          :match="track.expectTrackWordCopyrightList[0]"
        ></copyright>
      </el-col>
      <el-col :span="8">
        <copyright
          ref="music"
          :type="COPYRIGHT_TYPE.MUSIC"
          :editing="editing"
          :list="track.trackMusicCopyrightList"
          :match="track.expectTrackMusicCopyrightList[0]"
        ></copyright>
      </el-col>
    </el-row>
    <el-divider></el-divider>

    <out-plat :editing="editing" ref="outPlat" :list="track.trackCopyrightCompetitorList"></out-plat>

    <el-divider></el-divider>
    <div class="base-title">审核</div>

    <audit-form :track="track" ref="audit"></audit-form>
  </div>
</template>

<script>
import {
  cpDefectMap, isOnlyMap, authTypeMap, productMap, hideReasonMap,
  trackStatusMap, versionMap, paymentMap
} from '../../const'
import Copyright from './Copyright.vue'
import OutPlat from './OutPlat.vue'
import AuditForm from './AuditForm.vue'
import { COPYRIGHT_TYPE } from '../const'

export default {
  name: 'InfoItem',

  components: {
    Copyright,
    OutPlat,
    AuditForm
  },

  props: {
    track: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      COPYRIGHT_TYPE,
      productMap,
      cpDefectMap,
      isOnlyMap,
      authTypeMap,
      hideReasonMap,
      trackStatusMap,
      versionMap,
      paymentMap,

      editing: false,
      fileList: [],

      form: {
        cpDefect: '',
        isOnly: '',
        product: '',

        companyId: '',
        cpCompanyId: '',

        copyrightFrom: '',
        copyrightTo: '',
      },
    }
  },

  methods: {
    async getData() {
      const base = { ...this.track }

      const trackCopyrightCompetitorList = await this.$refs.outPlat.getData()
      const expectTrackCopyright = await this.$refs.track.getData()
      const expectTrackWordCopyright = await this.$refs.word.getData()
      const expectTrackMusicCopyright = await this.$refs.music.getData()
      const audit = await this.$refs.audit.getData()

      return {
        ...base,
        ...audit,
        trackCopyrightCompetitorList,
        expectTrackCopyrightList: [expectTrackCopyright],
        expectTrackWordCopyrightList: [expectTrackWordCopyright],
        expectTrackMusicCopyrightList: [expectTrackMusicCopyright],
      }
    },
    handleEdit() {
      this.editing = !this.editing
    },

  }
}
</script>

<style lang="scss" scoped>

.copyright-status {
  display: inline-block;
  vertical-align: top;
}

.base-title {
  margin: 10px 0;
  font-weight: bold;
  font-size: 16px;
}

.track-item {
  margin-top: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 0 20px;
}
</style>
